import React from "react";
import { NavLink } from "react-router-dom";
import classes from "./NavigationItem.css";

const navigationItem = (props) => {
   let isActive = false;
   let route = "/" + props.navclick;

   if (window.location.pathname === route) {
      isActive = true;
   }

   return (
      <li className={classes.NavigationItem}>
         <NavLink to={route} className={isActive ? classes.active : null}>
            <span>{props.children}</span>
         </NavLink>
      </li>
   );
};

export default navigationItem;



// WEBPACK FOOTER //
// ./src/components/Navigation/NavigationItems/NavigationItem/NavigationItem.js